// iot-sensor-app/src/components/EditSensorCard.js
import React, { useState, useEffect, useRef } from 'react';
import {  Avatar, Container, Typography,Grid2, Paper, CssBaseline, Box, Button, TextField, ListItem, ListItemIcon, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar} from '@mui/material';
import { FixedSizeList } from "react-window";
import SensorsIcon from '@mui/icons-material/Sensors';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import Co2Icon from '@mui/icons-material/Co2';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import InputAdornment from '@mui/material/InputAdornment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UploadIcon from '@mui/icons-material/Upload';
import RestartAltIcon from '@mui/icons-material/RestartAlt';


const RenameDialogContent = ({id, oldName, setName, handleEditName}) => {
  return (
    <>
    <DialogContent> {/* 添加底部间距 */}
      <DialogTitle style={{ marginTop: '0px', marginBottom: '16px', textAlign: 'center' }}> RENAME <br/> MAC: {id.toUpperCase()} <br/> Current Name : {oldName}</DialogTitle> {/* 添加文本居中对齐 */}
        <TextField
          label="Edit Name"
          variant="outlined"
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
      <Button variant="contained" onClick={handleEditName} style={{ margin: '0 auto' }}>Save</Button>
    </DialogActions>
    </>
  );
};

const DeleteDialogContent = ({id, oldName, handleDeleteSensor}) => {

  return (
    <>
    <DialogContent> {/* 添加底部间距 */}
      <DialogTitle style={{ marginTop: '0px', marginBottom: '16px', textAlign: 'center' }}> DELETE <br/> MAC: {id.toUpperCase()} <br/> Current Name : {oldName}</DialogTitle> {/* 添加文本居中对齐 */}
      <Typography style={{ textAlign: 'center' ,color: 'red'}}>Are you sure to delete this sensor?</Typography>
      </DialogContent>
      <DialogActions>
      <Button variant="contained" onClick={handleDeleteSensor} style={{ margin: '0 auto' }}>Confirm</Button> {/* 添加样式以居中按钮 */}
    </DialogActions>
    </>
  );
};

const handleUpdateCo2CalibrationEnable = async (id, enable) => {
  const response_enable = await fetch('/api/sensor/update_CO2_CAL_enable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, enable:enable}),
  });
}

const handleUpdateCo2CalibrationValue = async (id, value) => {
  const response_value = await fetch('/api/sensor/update_CO2_CAL_value', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, value: value}),
  });
}

const handleUpdateTempCalibrationEnable = async (id, enable) => {
  const response_enable = await fetch('/api/sensor/update_TEMP_CAL_enable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, enable:enable}),
  });
}

const handleUpdateTempCalibrationValue = async (id, value) => {
  const response_value = await fetch('/api/sensor/update_TEMP_CAL_value', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, value: value}),
  });
}

const handleUpdateUplodateEnable = async (id, enable) => {
  console.log(id, enable);
  const response_enable = await fetch('/api/sensor/update_upload_enable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, enable:enable}),
  });
}

const handleUpdateResetEnable = async (id, enable) => {
  const response_enable = await fetch('/api/sensor/update_reset_enable', {
    method: 'POST',
    body: JSON.stringify({ id: id, enable:enable}),
  });
}

const Row = ({ index, Toggledindex, data, style, setOpen, id, setId, setOldName, setDeleteOpen, refreshData, setToggleID}) => {
  const [CO2CAL, setCO2CAL] = useState(data['CO2_CAL'] ? JSON.parse(data['CO2_CAL']) : null);
  const [CO2CAL_enable, setCO2CAL_enable] = useState(CO2CAL ? CO2CAL.enable : false);
  const [CO2CAL_value, setCO2CAL_value] = useState(CO2CAL ? CO2CAL.value : 0);

  const [TEMPCAL, setTEMPCAL] = useState(data['TEMP_CAL'] ? JSON.parse(data['TEMP_CAL']) : null);
  const [TEMPCAL_enable, setTEMPCAL_enable] = useState(TEMPCAL ? TEMPCAL.enable : false);  
  const [TEMPCAL_value, setTEMPCAL_value] = useState(TEMPCAL ? TEMPCAL.value : 0);

  // Sync state when data prop changes (e.g. after save/enable)
  useEffect(() => {
    const parsedCO2 = data['CO2_CAL'] ? JSON.parse(data['CO2_CAL']) : null;
    setCO2CAL(parsedCO2);
    setCO2CAL_enable(parsedCO2 ? parsedCO2.enable : false);
    setCO2CAL_value(parsedCO2 ? parsedCO2.value : 0);

    const parsedTemp = data['TEMP_CAL'] ? JSON.parse(data['TEMP_CAL']) : null;
    setTEMPCAL(parsedTemp);
    setTEMPCAL_enable(parsedTemp ? parsedTemp.enable : false);
    setTEMPCAL_value(parsedTemp ? parsedTemp.value : 0);
  }, [data['CO2_CAL'], data['TEMP_CAL']]);

    return (
      <div style={{height: index === Toggledindex ? 300 : 150, left: style.left,right: style.right,top: (index > Toggledindex && Toggledindex !== -1) ? style.top + 150 : style.top ,bottom: (index > Toggledindex && Toggledindex !== -1) ? style.bottom + 150 : style.bottom,position: style.position, width: style.width}}>
        <ListItem >
          <Paper elevation={2} style={{ borderRadius: '8px', padding: '8px', minWidth: '100%'}}> 
            <Grid2 container alignItems="center" spacing={1}>
              <Grid2 item >
                <ListItemIcon>
                  <Avatar variant="rounded" style={{ backgroundColor: '#009999' }}>
                    {data['type'] == 'sensor' && <SensorsIcon />}
                    {data['type'] == 'aqmesh' && <FmdGoodIcon />}
                  </Avatar>
                </ListItemIcon>
              </Grid2>
              
              <Grid2 item size="grow" >
              <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '15px'}}
                >
                  {data['name'] ? data['name'].toUpperCase() : 'null'}
                </Typography>
                <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '13px'}}
                >
                  {data['deviceId'].toUpperCase()}
                </Typography>
              </Grid2>

              <Grid2 item xs={1} >
                <IconButton color="inherit" onClick={() => { index === Toggledindex ? setToggleID('') : setToggleID(id)}}>
                  <ExpandMoreIcon />
                </IconButton>
              </Grid2 >
            </Grid2>

            {index === Toggledindex ? 
            <div>
              <Grid2 container alignItems="center" spacing={1} pt={1} justifyContent="space-between">
              <Grid2 item size={4} pl={1}>
                <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '13px'}}
                >
                  Last Updated:
                  <br/>
                  {data['CO2_CAL_ts'] ? `${new Date((data['CO2_CAL_ts'] * 1000 + 8 * 60 * 60 * 1000) ).toISOString().split('T')[0]} ${new Date((data['CO2_CAL_ts'] * 1000 + 8 * 60 * 60 * 1000) ).toISOString().split('T')[1].split('.')[0]}` : 'N/A'}
                </Typography>
              </Grid2>

              <Grid2 item size={3} pl={1}>
              <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '14px'}}
                >
                  {data?.SCD ? (() => {
                    const rawCO2 = parseFloat(JSON.parse(data['SCD'])['3']);
                    const offset = CO2CAL?.offset || 0;
                    const displayCO2 = CO2CAL_enable ? (rawCO2 - offset).toFixed(1) : rawCO2;
                    return `CO2: ${displayCO2}${CO2CAL_enable ? ' (cal)' : ''}`;
                  })() : 'null'}
                  <br/>
                  {CO2CAL?.offset && CO2CAL_enable ? `Offset: ${CO2CAL.offset.toFixed(1)}` : (CO2CAL?.error ? `Error: ${CO2CAL?.error}` : 'null')}
                </Typography>
              </Grid2>
                <Grid2 item size={3}>
                    <TextField
                    size="small"
                    variant="outlined"
                    value={CO2CAL_value}
                    onChange={(e) => setCO2CAL_value(e.target.value)}
                    InputProps={{
                      endAdornment:
                        <InputAdornment position="end">
                          {(CO2CAL_value === "") ? (
                            <IconButton onClick={() => setCO2CAL_value(CO2CAL?.value)}>
                              <RefreshIcon /> 
                            </IconButton>
                          ) : (String(CO2CAL_value) !== String(CO2CAL?.value) && CO2CAL_value !== 0) ? (
                            <IconButton onClick={async () => { await handleUpdateCo2CalibrationValue(id, CO2CAL_value); refreshData(); }}>
                              <CheckIcon />
                            </IconButton>
                          ) : null}
                        </InputAdornment>
                    }}
                    />
                </Grid2>

                <Grid2 item xs={1} >
                  <IconButton color="inherit" onClick={async () => {await handleUpdateCo2CalibrationEnable(id, !CO2CAL_enable);refreshData()}}>
                    <Co2Icon 
                      style={{ color: (CO2CAL_enable) ? 'green' : 'red' }}
                    />
                  </IconButton>
                </Grid2>
              </Grid2>

              <Grid2 container alignItems="center" spacing={1} pt={1} justifyContent="space-between">
              <Grid2 item size={4} pl={1}>
                <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '13px'}}
                >
                  Temp Calibration:
                  <br/>
                  {data['TEMP_CAL_ts'] ? `${new Date((data['TEMP_CAL_ts'] * 1000 + 8 * 60 * 60 * 1000) ).toISOString().split('T')[0]} ${new Date((data['TEMP_CAL_ts'] * 1000 + 8 * 60 * 60 * 1000) ).toISOString().split('T')[1].split('.')[0]}` : 'N/A'}
                </Typography>
              </Grid2>

              <Grid2 item size={3} pl={1}>
              <Typography 
                  variant="h6"
                  style={{ color: 'primary', fontSize: '14px'}}
                >
                  {data?.SCD ? (() => {
                    const rawTemp = parseFloat(JSON.parse(data['SCD'])['0']) / 10;
                    const offset = TEMPCAL?.offset || 0;
                    const displayTemp = TEMPCAL_enable ? (rawTemp - offset).toFixed(1) : rawTemp.toFixed(1);
                    return `Temp: ${displayTemp}°C${TEMPCAL_enable ? ' (cal)' : ''}`;
                  })() : 'null'}
                  <br/>
                  {TEMPCAL?.offset && TEMPCAL_enable ? `Offset: ${TEMPCAL.offset.toFixed(1)}°C` : (TEMPCAL?.error ? `Error: ${TEMPCAL?.error}` : 'null')}
                </Typography>
              </Grid2>
                <Grid2 item size={3}>
                    <TextField
                    size="small"
                    variant="outlined"
                    value={TEMPCAL_value}
                    onChange={(e) => setTEMPCAL_value(e.target.value)}
                    InputProps={{
                      endAdornment:
                        <InputAdornment position="end">
                          {(TEMPCAL_value === "") ? (
                            <IconButton onClick={() => setTEMPCAL_value(TEMPCAL?.value)}>
                              <RefreshIcon /> 
                            </IconButton>
                          ) : (String(TEMPCAL_value) !== String(TEMPCAL?.value) && TEMPCAL_value !== 0) ? (
                            <IconButton onClick={async () => { await handleUpdateTempCalibrationValue(id, TEMPCAL_value); refreshData(); }}>
                              <CheckIcon />
                            </IconButton>
                          ) : null}
                        </InputAdornment>
                    }}
                    />
                </Grid2>

                <Grid2 item xs={1} >
                  <IconButton color="inherit" onClick={async () => {await handleUpdateTempCalibrationEnable(id, !TEMPCAL_enable);refreshData()}}>
                    <DeviceThermostatIcon 
                      style={{ color: (TEMPCAL_enable) ? 'green' : 'red' }}
                    />
                  </IconButton>
                </Grid2>
              </Grid2>
              

              <Grid2 container alignItems="center" spacing={1} pt={1} justifyContent="flex-end">

                <Grid2 item xs={1} >
                  <IconButton color={data.reset ? 'success' : 'inherit'} onClick={() => {handleUpdateResetEnable(id, !data.reset);refreshData()}}>
                    <RestartAltIcon />
                  </IconButton>
                </Grid2>

                <Grid2 item xs={1} >
                  <IconButton color={data.upload ? 'success' : 'inherit'} onClick={() => {handleUpdateUplodateEnable(id, !data.upload);refreshData()}}>
                    <UploadIcon />
                  </IconButton>
                </Grid2>

                <Grid2 item xs={1} >
                  <IconButton color="inherit" onClick={() => {setOpen(true); setId(id); setOldName(data['name'])}}> {/* 打开模态框 */}
                    <EditIcon />
                  </IconButton>
                </Grid2 >
                
                <Grid2 item xs={1} >
                  <IconButton color="inherit" disabled={data['type'] === 'aqmesh'} onClick={() => {setDeleteOpen(true); setId(id); setOldName(data['name'])}}> {/* 打开模态框 */}
                    <DeleteIcon />
                  </IconButton>
                </Grid2 >
              </Grid2>
              </div>
              : null}

          </Paper>
        </ListItem>
      </div>
    );
};


const EditSensor = () => {
  const [sensorData, setSensorData] = useState({});
  const [searchName, setSearchName] = useState("");
  const [open, setOpen] = useState(false); // 添加状态管理
  const [oldName, setOldName] = useState("");
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const containerRef = useRef(null);

  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);

  const [isLoaded, setIsLoaded] = useState(false);

  const [ToggleID, setToggleID] = useState('');

  const refreshData = () => {
    setSensorData({});
    fetchLastRecord();
    fetchAQMeshData();
  };

  const fetchLastRecord = async () => {
    try {
      const response = await fetch('/api/sensor/lastrecord');
      const data = await response.json();
      if (data.error){
        window.location.href = '/';
        return;
      }
      Object.entries(data).forEach(([sensorId, sensorData]) => {
        const currentTime = new Date(sensorData.timestamp).getTime();
        const SCDdata = sensorData.SCD ? JSON.parse(sensorData.SCD) : null;
        const SFAdata = sensorData.SFA ? JSON.parse(sensorData.SFA) : null;
        const SPSdata = sensorData.SPS ? JSON.parse(sensorData.SPS) : null;

        setSensorData(prevData => ({
          ...prevData,
          [sensorId]: { type: 'sensor', sps: SPSdata,scd: SCDdata, sfa: SFAdata, ...sensorData } // 更新 SPS 数据
        }));
      });
    } catch (error) {
      console.error('Error fetching last record:', error);
    }
    setIsLoaded(true);
  };

  const fetchAQMeshData = async () => {
    try {
      const response = await fetch('/api/aqmesh/lastrecord');
      const data = await response.json();
      if (data.error){
        window.location.href = '/';
        return;
      }
      Object.entries(data).forEach(([sensorId, sensorData]) => {
        const currentTime = new Date(sensorData.timestamp).getTime();
        const aqmeshData = sensorData.aqmesh ? JSON.parse(sensorData.aqmesh) : null;

        setSensorData(prevData => ({
          ...prevData,
          [sensorId]: { type: 'aqmesh', aqmesh: aqmeshData, ...sensorData } // 更新 SPS 数据
        }));
      });
    } catch (error) {
      console.error('Error fetching last record:', error);
    }
    setIsLoaded(true);
  };

  

  useEffect(() => {
    fetchLastRecord();
    fetchAQMeshData();
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const handleEditName = async () => {

    if(sensorData[id].type === 'aqmesh'){
      const response = await fetch('/api/aqmesh/edit_sensor_name', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: id, name: name }),
      });
      const result = await response.json();
    
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true);
      setOpen(false);
      setSensorData({});
      fetchLastRecord();
      fetchAQMeshData();
    };

    if(sensorData[id].type === 'sensor'){
    const response = await fetch('/api/sensor/edit_sensor_name', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: id, name: name }),
      });
      const result = await response.json();
    
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true);
      setOpen(false);
      setSensorData({});
      fetchLastRecord();
      fetchAQMeshData();
    }
  }

  const handleDeleteSensor = async () => {

    if(sensorData[id].type === 'aqmesh'){
      const response = await fetch('/api/aqmesh/delete_sensor', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: id , name: name}),
      });
      const result = await response.json();
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true);
      setDeleteOpen(false);
      setSensorData({});
      fetchLastRecord();
      fetchAQMeshData();
    }
    if(sensorData[id].type === 'sensor'){
      const response = await fetch('/api/sensor/delete_sensor', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: id , name: name}),
      });
      const result = await response.json();
      if (result.success){
        setSeverity("success");
        setSnackbarMessage(result.success);
      }else{
        setSeverity("error");
        setSnackbarMessage(result.error);
      }
      setSnackbarOpen(true);
      setDeleteOpen(false);
      setSensorData({});
      fetchLastRecord();
      fetchAQMeshData();
    }   
  }

  const filteredRecords = searchName 
    ? Object.entries(sensorData)
        .filter(([sensorId, data]) => (
          (data.deviceId || '').toLowerCase().includes(searchName) ||
          (data.name || '').toLowerCase().includes(searchName)
        ))
        .sort(([, a], [, b]) => (a.name || '').localeCompare(b.name || '')).reverse()
        : Object.entries(sensorData)
        .sort(([, a], [, b]) => {
          const nameA = a.name || "";
          const nameB = b.name || "";
          return nameA.localeCompare(nameB);
        }).reverse();

  return (
    <Container ref={containerRef}>
      <CssBaseline />
      <Box my={4} mx="auto" display="flex" flexDirection="column" justifyContent="center" alignItems="center" minWidth="40%" maxWidth={window.innerWidth > 1200 ? "40%" : "90%"}>
      <Typography variant="h4" style={{ marginBottom: '16px' }}>Edit Sensor</Typography> {/* 修改为 Dashboard 标题 */}
      <TextField
        label="Search by MAC Address or Name"
        value={searchName}
        onChange={(e) => setSearchName(e.target.value.toLowerCase())}
        fullWidth
        style={{ marginBottom: '16px' }} // 添加底部间距
        InputProps={{
          endAdornment: (
            searchName && (
            <InputAdornment position="end">
              <IconButton onClick={() => {setSearchName('')}}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
            )
          ),
        }}
      />

      <FixedSizeList
        height={375}
        itemSize={75}
        itemCount={filteredRecords.length} // 项的数量 + 1 for header
        width="100%" // 列表宽度
        onMouseDown={(e) => e.preventDefault()} // 禁用鼠标事件
        onMouseLeave={(e) => e.preventDefault()} // 禁用触摸事件
      >
        {({ index, style }) => {
          const [id, data] = filteredRecords[index]; // 获取传感器ID和数据
          //console.log(style, index)
          //get the id in the filteredRecords
          return (
            <Row id={data['deviceId']} index={index} Toggledindex = {filteredRecords.map((arr) => arr[0]).indexOf(ToggleID)} data={data} style={style} setOpen={() => setOpen(true)} key={id} setId={setId} setOldName={setOldName} setDeleteOpen={setDeleteOpen} refreshData={refreshData} setToggleID={setToggleID}/>
          );
        }}

      </FixedSizeList>
    </Box>
    <Dialog open={open} onClose={() => {setName(""); setOpen(false)}} fullWidth maxWidth="xs"> {/* 使用 Dialog 替代 Modal */}
        <RenameDialogContent id={id} oldName={oldName} setName={setName} handleEditName={handleEditName} />
    </Dialog>
    <Dialog open={deleteOpen} onClose={() => {setId(""); setDeleteOpen(false)}} fullWidth maxWidth="xs"> {/* 使用 Dialog 替代 Modal */}
        <DeleteDialogContent id={id} oldName={oldName} setName={setName} handleDeleteSensor={handleDeleteSensor} />
    </Dialog>
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={2000}
      onClose={() => setSnackbarOpen(false)}
    >
      <Alert  variant="filled" onClose={() => setSnackbarOpen(false)} severity={severity} sx={{ width: '100%' }}>{snackbarMessage}</Alert>
    </Snackbar>
    </Container>
  );
};

export default EditSensor;